import { render, staticRenderFns } from "./ModalAssistantSvf.vue?vue&type=template&id=49232f96&"
import script from "./ModalAssistantSvf.vue?vue&type=script&lang=js&"
export * from "./ModalAssistantSvf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports